import React from 'react';
import { ReferenceField } from '@uncinc/react-drupal-core/types';
import LinkTags from './LinkTags';

import { TaxonomyThemes } from '../../types/uncinc_profile/taxonomy';

import './style.scss';
import { LinkTagProps } from './LinkTags/LinkTag';

interface ThemesLabelsProps {
  themes?: ReferenceField<TaxonomyThemes>[];
  isMainTheme?: boolean;
}

const ThemesLabels = ({ themes, isMainTheme = false }: ThemesLabelsProps) => {
  if (!themes || themes.length === 0) return null;
  const tagListThemes: Array<LinkTagProps> = [];
  themes?.forEach((theme) => {
    const name = theme.entity?.name[0]?.value;
    const url = theme.entity?.paths.nl;

    if (name) {
      tagListThemes.push({
        name,
        url,
      } as LinkTagProps);
    }
  });

  return (
    <LinkTags tags={tagListThemes} className={`${isMainTheme ? 'LinkTags__mainTheme' : ''}`} />
  );
};

export default ThemesLabels;
